const module = { name: '@fd-assets/core-styles/loadingBars', exports: {} }; const exports = module.exports;



import { Fandango_debugLog as debugLog } from '@grins/fd-modules/splits/onering-global';



const Styles = {
    WRAPPER: 'loading-bars__btn-wrap--processing',
    BTN_PROCESSING: 'loading-bars__btn--processing',
    HIDE: 'hide',
}


const ID_PLACEHOLDER = '<%=id%>'


const LoadingElementHTML = `<span class="loading-bars loading-bars--element ${Styles.HIDE}" id="${ID_PLACEHOLDER}">
      <span class="loading-bars__bar loading-bars__bar--element"></span>
      <span class="loading-bars__bar loading-bars__bar--element"></span>
      <span class="loading-bars__bar loading-bars__bar--element"></span>
  </span>`


let lastId = 0
function newID() {
    return `loading-bars_${++lastId}_${Date.now()}`;
}
function getLoader(btn) {
    const wrapper = document.getElementById(btn.dataset.loadingBars);
    return document.getElementById(wrapper.dataset.loaderId);
}
function toggleAnimation(btn, isHidden) {
    getLoader(btn).classList.toggle(Styles.HIDE, isHidden);
}
function addWrapper(btn, opts) {
    const wrapperID = newID();
    const loaderID = newID();
    const wrapper = document.createElement('span');
    wrapper.id = wrapperID;
    wrapper.classList.add(Styles.WRAPPER);
    wrapper.dataset.loaderId = loaderID;
    wrapper.innerHTML = LoadingElementHTML.replace(ID_PLACEHOLDER, loaderID);
    const { className } = opts || {};
    if (className) {
        wrapper.classList.add(className);
    }
    btn.parentNode.insertBefore(wrapper, btn);
    wrapper.appendChild(btn);
    const loader = document.getElementById(loaderID);
    loader.before(btn);
    return wrapperID;
}
function wrapBtn(btn, opts) {
    if (!btn || !btn.dataset) {
        debugLog.error(module.name, 'button is not a valid element', btn);
        return null;
    }
    if (!btn.dataset.loadingBars) {
        const id = addWrapper(btn, opts);
        btn.dataset.loadingBars = id;
    }
    return btn;
}
function start(btn, opts) {
    if (!wrapBtn(btn, opts)) {
        return;
    }
    toggleAnimation(btn, false);
    btn.classList.add(Styles.BTN_PROCESSING);
    btn.setAttribute('disabled', true);
}
function stop(btn) {
    if (!wrapBtn(btn)) {
        return;
    }
    toggleAnimation(btn, true);
    btn.classList.remove(Styles.BTN_PROCESSING);
    btn.removeAttribute('disabled');
}
module.exports = {
    start,
    stop
};
export default module.exports;